import { useMutation } from '@tanstack/react-query';
import { RolesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useRolesControllerCreateRoleMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['rolesControllerCreateRole', accessControlScope],
        mutationFn: async (args) => {
            const api = new RolesApi(accessControlConfig);
            return api.rolesControllerCreateRole(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useRolesControllerCreateRoleMutation.js.map